import { Progress } from '@gusto/workbench';
import estimatePasswordStrength from '../../helpers/estimate_password_strength';

const PasswordStrengthBar = password => {
  const inputPassword = password.password;
  let tempScore = 0;
  const SCORE_COPY = {
    0: 'Too weak',
    1: 'Weak',
    2: 'Fair',
    3: 'Good',
    4: 'Strong',
  };

  const scoreToPercentage = () => {
    if (inputPassword === '') return 0;
    const scoreFromAlgorithm = estimatePasswordStrength(inputPassword);
    const result = scoreFromAlgorithm.score * 20 + 20;
    tempScore = scoreFromAlgorithm.score;
    return result;
  };

  const scoreToBarColor = score => {
    return score < 2 ? 'secondary' : 'primary';
  };

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <Progress
            name="Password strength"
            aria-label="Password strength"
            aria-valuemin="0"
            aria-valuemax="100"
            aria-valuenow={scoreToPercentage()}
            color={scoreToBarColor(tempScore)}
            value={scoreToPercentage()}
            max={100}
          />
        </div>
        <div className="col-sm-12 mt-3">
          <p id="password-strength" className="text-small text-left  c-salt-800">
            Password strength:{' '}
            {inputPassword !== '' && (
              <span data-testid="password-strength-score" className="text-small strength-text">
                {' '}
                {SCORE_COPY[tempScore]}{' '}
              </span>
            )}
          </p>
        </div>
      </div>
    </>
  );
};
export default PasswordStrengthBar;
